export default {"src":"/_next/static/media/hottub.3d02d925.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};